"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfChangePhoneResponseDto = instanceOfChangePhoneResponseDto;
exports.ChangePhoneResponseDtoFromJSON = ChangePhoneResponseDtoFromJSON;
exports.ChangePhoneResponseDtoFromJSONTyped = ChangePhoneResponseDtoFromJSONTyped;
exports.ChangePhoneResponseDtoToJSON = ChangePhoneResponseDtoToJSON;
exports.ChangePhoneResponseDtoToJSONTyped = ChangePhoneResponseDtoToJSONTyped;
var UserResponseDto_1 = require("./UserResponseDto");
/**
 * Check if a given object implements the ChangePhoneResponseDto interface.
 */
function instanceOfChangePhoneResponseDto(value) {
    if (!('accessToken' in value) || value['accessToken'] === undefined)
        return false;
    if (!('refreshToken' in value) || value['refreshToken'] === undefined)
        return false;
    if (!('expiresIn' in value) || value['expiresIn'] === undefined)
        return false;
    if (!('profile' in value) || value['profile'] === undefined)
        return false;
    return true;
}
function ChangePhoneResponseDtoFromJSON(json) {
    return ChangePhoneResponseDtoFromJSONTyped(json, false);
}
function ChangePhoneResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'accessToken': json['accessToken'],
        'refreshToken': json['refreshToken'],
        'expiresIn': json['expiresIn'],
        'profile': (0, UserResponseDto_1.UserResponseDtoFromJSON)(json['profile']),
    };
}
function ChangePhoneResponseDtoToJSON(json) {
    return ChangePhoneResponseDtoToJSONTyped(json, false);
}
function ChangePhoneResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'accessToken': value['accessToken'],
        'refreshToken': value['refreshToken'],
        'expiresIn': value['expiresIn'],
        'profile': (0, UserResponseDto_1.UserResponseDtoToJSON)(value['profile']),
    };
}
